import { createContext } from "react";
import { useState, useEffect } from "react";
import { getDriver, getToken, saveToken } from "../services/utils/store";
import { get } from "http";
export type ClientContextType = {
  state: any;
  dispatch: (data: any) => void;
};

export const ClientContext = createContext<ClientContextType>({
  state: {},
  dispatch: () => { }
});

export const ClientStorage = ({ children }: any) => {
  const [state, setState] = useState(() => {
    const storedToken = getToken();
    return { token: storedToken || null };
  });

  const dispatch = (data: any) => {
    setState((state: any) => {
      const newState = { ...state, ...data };
      if (data.token) {
        saveToken(data.token);
      }
      if (data.user) {
        localStorage.setItem('user', JSON.stringify(data.user));
      }
      if (data.driver) {
        localStorage.setItem('driver', JSON.stringify(data.driver));
      }
      return newState;
    });
  };

  useEffect(() => {
    const token = getToken();
    const driver = getDriver();
    const userStr = localStorage.getItem('user');

    if (token) {
      setState((prevState) => ({
        ...prevState,
        token: token
      }));
    }
    if (driver) {
      setState((prevState) => ({
        ...prevState,
        driver: JSON.parse(driver)
      }));
    }
    if (userStr) {
      setState((prevState) => ({
        ...prevState,
        user: JSON.parse(userStr)
      }));
    }
  }, []);

  return (
    <ClientContext.Provider value={{ state: state, dispatch: dispatch }}>
      {children}
    </ClientContext.Provider>
  );
};

